/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    var $datatable = $('#datatable-all-rooms-search'),
        $dt;

    var dataTables_buttons = [
        {
            extend: 'csv',
            text: 'Export as CSV',
            exportOptions: {
                columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13 ]
            },
        },
        {
            extend: 'pdf',
            text: 'Export as PDF',
            exportOptions: {
                columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9 ]
            }
        },
        {
            extend: 'colvis',
        }
    ];

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/properties/rooms-search",
            "method": 'POST',
            "data": function ( d ) {
                d.status_id = $('input[name="clickedStatusId"]').val();
                d.type_id = $('input[name="clickedTypeId"]').val();
            }
        },
        "buttons": dataTables_buttons,
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": [
            { data: 'name',           name: 'name', title: 'Name', className: "fs-13", searchable: true, orderable: true, width: "1%" },
            { data: 'status_id',      name: 'status_id', title: 'Status', className: "centerize", searchable: false, orderable: true, width: "1%" },
            { data: 'key_number',     name: 'key_number', title: 'Keys', width: "1%", className: "centerize", orderable: false, searchable: false, visible: false },
	        { data: 'is_couple',       name: 'is_couple', title: 'Couple?', className: "fs-13", orderable: false, searchable: true },
            { data: 'guardian',       name: 'guardian', title: 'Guardian', className: "fs-13", orderable: false, searchable: true },
            { data: 'start',          name: 'start', title: 'Start rent', className: "fs-13", orderable: false, searchable: true, width: "8%"},
            { data: 'end',            name: 'end', title: 'End rent', className: "fs-13", orderable: false, searchable: true, width: "8%"},
            { data: 'price',          name: 'price', title: 'Price', className: "fs-13"},

            { data: 'property_name',  name: 'property.name', title: 'Property', className: "fs-13" },
            { data: 'property_id',    name: 'property.property_id', title: 'ID', className: "fs-13", searchable: true, orderable: true, visible: false },
            { data: 'property_am',    name: 'property.client.manager', title: 'AM', className: "fs-13", searchable: true, orderable: true, visible: false },
            { data: 'postcode',       name: 'property.postcode', title: 'Postcode', className: "fs-13", searchable: true, orderable: true },
	        { data: 'date_notice',    name: 'property.date_notice', title: 'Notice Date', className: "fs-13", searchable: false, orderable: false},

            { data: 'company_name',   name: 'property.client.name', title: 'Client', className: "fs-13", searchable: true, orderable: true },

            { data: 'actions',        name: 'actions', searchable: false, orderable: false, className : "action" }
        ],
        "columnDefs": [
            {
                "targets": 8,
                "type": "string",
                "orderable": true,
                "searchable": true,
                "useRendered": false
            },

        ]
    });

    $('.js-room-overview-box').on('click', function() {
        var $this = $(this),
            $clickedStatusId = $('input[name="clickedStatusId"]'),
            $clickedTypeId = $('input[name="clickedTypeId"]'),
            statusId = $(this).data('status_id'),
            typeId = $(this).data('type_id');

        $clickedStatusId.val( statusId );
        $clickedTypeId.val( typeId );

        $dt.ajax.reload();
    });

});
